import { makeStyles } from '@material-ui/core';

export const usePersonProfileStyles = makeStyles(theme => ({
  button: {
    margin: theme.spacing(1),
  },
  avatarGrid: {
    marginTop: 15,
  },
  uploadFilesGrid: {
    textAlign: 'center',
    display: 'none',
  },
  passwordLabelGrid: {
    textAlign: 'center',
    marginBottom: 10,
    visibility: 'hidden',
  },
  contactChannelContainer: {
    marginTop: 5,
    marginBottom: 6,
    alignItems: 'center',
  },
  contactChannelValueGrid: {
    textAlign: 'end',
  },
  submitButtonGrid: {
    textAlign: 'center',
    marginTop: 50,
  },
  errorMessage: {
    color: 'red',
  },
}));

export const useRolesAndCertsStyles = makeStyles(theme => ({
  titleBox: {
    borderBottomWidth: '1px',
    borderBottomColor: theme.palette.grey[600],
    borderBottomStyle: 'solid',
  },
  titleText: {
    color: theme.palette.grey[600],
  },
  text: {
    minHeight: '60px',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
}));

export const useRegistrationsStyles = makeStyles(theme => ({
  titleBox: {
    borderBottomWidth: '1px',
    borderBottomColor: theme.palette.grey[600],
    borderBottomStyle: 'solid',
  },
  titleText: {
    color: theme.palette.grey[600],
  },
}));
